import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormHelperText,
  Grid,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { CheckBox } from "@mui/icons-material";
import { useGetTokenOrLogout } from "../../../utils/token";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const CreateClassDialog = ({
  open,
  onClose,
  onSubmit,
  room_Name,
  roomId,
  branchId,
  updateRoomSchedule,
  room_Teaching_mode,
  roomCapacity,
}) => {
  const adminId = localStorage.getItem("adminId");
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const idbranch = branchId;
  const idroom = roomId;
  const [testTypes, setTestTypes] = useState([]);
  const [modules, setModules] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [className, setClassName] = useState("");
  const [roomName, setRoomName] = useState(room_Name);
  const [testType, setTestType] = useState(null);
  const [module, setModule] = useState("");
  const [trainer, setTrainer] = useState("");
  const [deliveryMode, setDeliveryMode] = useState();
  const [branchLocation, setBranchLocation] = useState("");
  // const [startDate, setStartDate] = useState('');
  // const [endDate, setEndDate] = useState('');
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [capacity, setCapacity] = useState(null);
  const [zoomLink, setZoomLink] = useState(null);
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const [daysList, setDaysList] = useState([]);
  const [selectedDay, setSelectedDay] = useState([]);
  const [isDemo, setIsDemo] = useState(false);
  const [allSelected, setAllSelected] = useState(false);
  const [maximumDemo, setMaximumDemo] = useState(null);
  const [errors, setErrors] = useState({
    roomName: "",
    testType: "",
    trainer: "",
    zoomLink: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    capacity: "",
    selectedDay: [],
    maximumDemo: null || "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleModuleChange = (event) => {
    setModule(event.target.value);
  };

  useEffect(() => {
    // const fetchTestTypes = async () => {
    //   try {
    //     const response = await fetch(`${API_ENDPOINT}route/getalltesttype`);
    //     const data = await response.json();

    //     setTestTypes(data);
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };

    const fetchModules = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}admindashboard/getmodule`);
        const data = await response.json();
        setModules(data);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTrainers = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route/activetrainers/${idbranch}`
        );

        if (response.status === 403) {
          // Handle 403 error by setting trainers to an empty array
          setTrainers([]);
          console.error("Forbidden - 403 Error");
          return;
        }

        const data = await response.json();
        setTrainers(data);
      } catch (error) {
        console.error("Error fetching trainers:", error);
      }
    };

    const fetchBranches = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}admindashboard/getbranch`);
        const data = await response.json();
        setBranches(data);
      } catch (error) {
        console.error(error);
      }
    };

    // fetchTestTypes();
    fetchModules();
    fetchTrainers();
    fetchBranches();
  }, []);

 const fetchtesttypes = async () => {
    const requestData = {
      room_id: parseInt(idroom),
      user_id: parseInt(userId),
      is_demo :isDemo
    };

    try {
      const response = await fetch(`${API_ENDPOINT}testtype/byroom`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (response.ok) {
        const data=await response.json()
       setTestTypes(data)
      }  else {
        showSnackbar("Server error", "error");
      }
    } catch (error) {
      console.error("Network or Server Error:", error);
      showSnackbar("Server error", "error");
    }
  };

  useEffect(() => {
    fetchtesttypes()
  

  }, [roomId,isDemo])
  


  // Fetch Upcomming Event
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}week`);
        if (response.ok) {
          const data = await response.json();

          setDaysList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // const handledaysChange = (e, dayId) => {
  //   console.log("value",dayId)
  //   if (e.target.checked) {
  //     if(dayId==="all"){
  //       const ids = daysList.map((i)=>i.id)
  //       setSelectedDay(ids)
  //     }
  //     else {
  //     setSelectedDay((prev) => [...prev, dayId]); // Add if checked
  //     }
  //   } else {
  //     setSelectedDay((prev) => prev.filter((id) => id !== dayId)); // Remove if unchecked
  //   }
  // };

  const handledaysChange = (e, dayId) => {
    if (e.target.checked) {
      if (dayId === "all") {
        const ids = daysList.map((i) => i.id);
        setSelectedDay(ids);
      } else {
        setSelectedDay((prev) => [...new Set([...prev, dayId])]);
      }
    } else {
      if (dayId === "all") {
        setSelectedDay([]);
      } else {
        setSelectedDay((prev) => prev.filter((id) => id !== dayId));
      }
    }
  };

  // Helper to check if all are selected

  useEffect(() => {
    const allSelected =
      daysList.length > 0 && selectedDay.length === daysList.length;
    setAllSelected(allSelected);
  }, [selectedDay]);

  console.log("allSelected", allSelected);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Validate roomName
    if (!roomName) {
      newErrors.roomName = "This is required field";
      isValid = false;
    } else {
      newErrors.roomName = "";
    }

    // Validate testType
    if (!testType) {
      newErrors.testType = "This is required field";
      isValid = false;
    } else {
      newErrors.testType = "";
    }

    // Validate trainer
    if (!trainer) {
      newErrors.trainer = "This is required field";
      isValid = false;
    } else {
      newErrors.trainer = "";
    }

    // Validate testType
    if (selectedDay.length === 0) {
      newErrors.selectedDay = "This is required field";
      isValid = false;
    } else {
      newErrors.selectedDay = "";
    }

    if (!startTime) {
      newErrors.startTime = "This is required field";
      isValid = false;
    } else {
      newErrors.startTime = "";
    }

    if (!endTime) {
      newErrors.endTime = "This is required field";
      isValid = false;
    } else {
      newErrors.endTime = "";
    }

    if (!maximumDemo && isDemo) {
      newErrors.maximumDemo = "This is required field";
      isValid = false;
    } else {
      newErrors.maximumDemo = "";
    }

    // Validate Zoom link for online classes
    if (room_Teaching_mode === "online" && !zoomLink) {
      newErrors.zoomLink = "Zoom Link is required for online classes";
      isValid = false;
    } else {
      newErrors.zoomLink = "";
    }

    setErrors(newErrors);

    return isValid;
  };

  // const handleSubmit = () => {
  //   // Perform form validation here if needed

  //   if (!validateForm()) {
  //     // If form is not valid, do not proceed with submission
  //     return;
  //   }

  //   const newClass = {
  //     // name:className,
  //     test_type_id: parseInt(testType),
  //     // module_id: parseInt(module),
  //     trainer_id: parseInt(trainer),
  //     //mode_of_delivery: deliveryMode,
  //     branch_id: parseInt(idbranch),
  //     room_id: idroom,
  //     day: selectedDay,
  //     //start_date: startDate,
  //     // end_date: endDate,
  //     start_time: startTime,
  //     end_time: endTime,
  //     is_demo: isDemo,
  //     demo_capacity:maximumDemo || null,
  //     zoom_link: zoomLink,
  //     // capacity: parseInt(capacity),
  //     user_id: parseInt(userId),
  //     //creator_id: parseInt(adminId)
  //   };

  //   //onSubmit(newClass);

  //   fetch(`${API_ENDPOINT}class`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(newClass),
  //   })
  //     /*.then(response => response.json())
  //     .then(data => {
  //       // Handle the response from the API if needed
  //       console.log('Class added:', data);
  //       alert('Class created successfully')
  //     })*/
  //     .then((response) => {
  //       const result=response.json()
  //       if (response.ok) {
  //         showSnackbar("Class created successfully", "success");
  //         updateRoomSchedule(newClass);
  //         // alert('Class created successfully')
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 1500);

  //         setClassName("");
  //         setTestType("");
  //         setModule("");
  //         setTrainer("");
  //         setDeliveryMode("");
  //         setBranchLocation("");
  //         //  setStartDate('')
  //         //setEndDate('')
  //         setStartTime("");
  //         setEndTime("");
  //         setCapacity(null);
  //         setZoomLink(null);
  //         setSelectedDay([]);

  //         setErrors({
  //           roomName: "",
  //           testType: "",
  //           trainer: "",
  //           zoomLink: "",
  //           startDate: "",
  //           endDate: "",
  //           startTime: "",
  //           endTime: "",
  //           capacity: "",
  //           setSelectedDay: [],
  //         });
  //       } else if (response.status === 409) {
  //         console.log("Error:", response);
  //         // alert('Error creating class')
  //         showSnackbar("Duplicate class in this room", "error");
  //       } else if (response.status === 401) {
  //         console.log("Error:", response);
  //         // alert('Error creating class')
  //         showSnackbar("Not a User", "error");
  //       } else if (response.status === 410) {
  //         console.log("Error:", response);
  //         // alert('Error creating class')
  //         showSnackbar("Trainer has a conflicting class at this time", "error");
  //       } else if (response.status === 400) {
  //         console.log("Error:", response);
  //         // alert('Error creating class')
  //         showSnackbar(result.message, "error");
  //       } else if (response.status === 404) {
  //         console.log("Error:", response);
  //         // alert('Error creating class')
  //         showSnackbar("Trainer not found or inactive", "error");
  //       } else {
  //         console.log("Error:", response);
  //         // alert('Error creating class')
  //         showSnackbar("Error creating class", "error");
  //       }
  //     })
  //     .catch((error) => {
  //       // Handle any errors that occurred during the fetch request
  //       console.error("Error adding class:", error);
  //       // alert('Error creating class')
  //       showSnackbar("Error creating class", "error");
  //     });
  // };



  const handleSubmit = async (event) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    if (!validateForm()) {
      // If form is not valid, do not proceed with submission
      return;
    }

      // Parse "HH:mm" into hours and minutes
  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);

  // Convert to total minutes
  const startTotalMinutes = startHours * 60 + startMinutes;
  const endTotalMinutes = endHours * 60 + endMinutes;
  console.log("startHours",startTotalMinutes)

  // Difference in minutes
  const diffInMinutes = endTotalMinutes - startTotalMinutes;

  if (diffInMinutes > 120) { // more than 2 hours
    showSnackbar(
     "Invalid time: difference cannot exceed 2 hours.", "error"
  
    );
    return;
  } else if (diffInMinutes <= 0) { // optional: end time earlier than start time
    showSnackbar(
    "End time must be after start time.", "error"
     );
    return;
  }

    const requestData = {
      test_type_id: parseInt(testType),
      // module_id: parseInt(module),
      trainer_id: parseInt(trainer),
      //mode_of_delivery: deliveryMode,
      branch_id: parseInt(idbranch),
      room_id: idroom,
      day: selectedDay,
      //start_date: startDate,
      // end_date: endDate,
      start_time: startTime,
      end_time: endTime,
      is_demo: isDemo,
      demo_capacity: maximumDemo || null,
      zoom_link: zoomLink,
      // capacity: parseInt(capacity),
      user_id: parseInt(userId),
    };

    try {
      const response = await fetch(`${API_ENDPOINT}class`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (response.ok) {
        showSnackbar(result.message, "success");
        setTimeout(() => {
          window.location.reload()
        }, 1500);
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Internal Server Error :", result.message, "error");
      }
    } catch (error) {
      showSnackbar("Internal Server Error :", "error");
    }
  };

  const handleCancel = () => {
    setSelectedDay([]);
    setTestType(null);
    setTrainer(null);
    setStartTime(null);
    setEndTime(null);
    setIsDemo(false);
    setErrors({
      roomName: "",
      testType: "",
      trainer: "",
      zoomLink: "",
      //startDate: '',
      // endDate: '',
      startTime: "",
      endTime: "",
      capacity: "",
      setSelectedDay: [],
    });

    onClose();
  };

  const handleClassDemoChange = (event) => {
    setMaximumDemo(null);

    setIsDemo(event.target.checked); // converts string to boolean
  };

  const handleStartTimeChange = (e) => {
  const value = e.target.value;
  if (value < "07:00" || value > "22:00") {
    setErrors((prev) => ({ ...prev, startTime: "Time must be between 07:00 and 22:00" }));
  } else {
    setErrors((prev) => ({ ...prev, startTime: "" }));
    setStartTime(value);
  }
};

  const handleEndTimeChange = (e) => {
  const value = e.target.value;
  if (value < "07:00" || value > "22:00") {
    setErrors((prev) => ({ ...prev, endTime: "Time must be between 07:00 and 22:00" }));
  } else {
    setErrors((prev) => ({ ...prev, endTime: "" }));
    setEndTime(value);
  }
};



  return (
    <>
      {/*} <TextField
          label="Class Name"
          fullWidth
          value={className}
          onChange={(e) => setClassName(e.target.value)}
          margin="normal"
  /> */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Room Assigned</Typography>
          <TextField
            size="small"
            fullWidth
            value={roomName}
            disabled
            // onChange={(e) => setRoomName(e.target.value)}
            InputProps={{ style: { borderRadius: "10px" } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Room Capacity</Typography>
          <TextField
            size="small"
            fullWidth
            value={roomCapacity}
            disabled
            // onChange={(e) => setRoomName(e.target.value)}
            InputProps={{ style: { borderRadius: "10px" } }}
          />
        </Grid>
         <Grid item xs={12} sm={6} container alignItems="center">
          <Typography variant="h5">Enable demo for this class </Typography>
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 21 } }}
            checked={isDemo}
            onChange={handleClassDemoChange}
          />
        </Grid>

        {isDemo && (
          <Grid item xs={12} sm={6}>
            <Typography variant="h6">
              Maximum Demo Capacity{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <TextField
              size="small"
              fullWidth
              value={maximumDemo}
              type="number"
              onChange={(e) => setMaximumDemo(e.target.value)}
              InputProps={{ style: { borderRadius: "10px" } }}
              error={Boolean(errors.maximumDemo)}
              helperText={errors.maximumDemo}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <FormControl fullWidth>
            <Typography variant="h6">
              Select Test Type{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Select
              size="small"
              value={testType}
              onChange={(e) => setTestType(e.target.value)}
              style={{ borderRadius: "10px" }}
            >
              {testTypes.map((testType) => (
                <MenuItem key={testType.id} value={testType.id}>
                  {testType.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.testType}</FormHelperText>
          </FormControl>
        </Grid>
        {/*}   <FormControl fullWidth margin="normal">
          <InputLabel>Modules</InputLabel>
          <Select
            //multiple
            value={module}
            onChange={handleModuleChange}
          >
            {modules.map((module) => (
          <MenuItem key={module.id} value={module.id}>
            {module.name}
          </MenuItem>
        ))}
            
          </Select>
        </FormControl>*/}

        <Grid item xs={12}>
          <FormControl fullWidth>
            <Typography variant="h6">
              Select Trainer{" "}
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>
            <Select
              size="small"
              value={trainer}
              onChange={(e) => setTrainer(e.target.value)}
              style={{ borderRadius: "10px" }}
            >
              {trainers.map((trainer) => (
                <MenuItem key={trainer.id} value={trainer.id}>
                  {trainer.first_name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.trainer}</FormHelperText>
          </FormControl>
        </Grid>
        {/*} <FormControl fullWidth margin="normal">
          <InputLabel>Delivery Mode</InputLabel>
          <Select
            value={deliveryMode}
            onChange={(e) => setDeliveryMode(e.target.value)}
          >
            <MenuItem value="online">Online</MenuItem>
            <MenuItem value="offline">Offline</MenuItem>
          </Select>
        </FormControl>
       {/*} {deliveryMode === 'offline' && (
          <FormControl fullWidth margin="normal">
          <InputLabel>Branch Location</InputLabel>
          <Select
            value={branchLocation}
            onChange={(e) => setBranchLocation(e.target.value)}
          >
            {branches.map((branch) => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.branch_name}
          </MenuItem>
        ))}
          </Select>
        </FormControl>
            )} 
        <TextField
          label="Start Date"
          fullWidth
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          error={Boolean(errors.startDate)}
          helperText={errors.startDate}
        />
        <TextField
          label="End Date"
          fullWidth
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          error={Boolean(errors.endDate)}
          helperText={errors.endDate}
        />*/}
        <Grid item xs={12}>
          <Typography variant="h6">
            Select Days{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="center"
            border="1px solid rgba(0, 0, 0, 0.23)"
            flexWrap="wrap"
            borderRadius="10px"
          >
            <>
              <FormControlLabel
                sx={{
                  alignItems: "center", // Ensures vertical center alignment
                }}
                control={
                  <Checkbox
                    checked={allSelected}
                    sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    onClick={(e) => handledaysChange(e, "all")}
                  />
                }
                label={<Typography variant="h6">Every day</Typography>}
              />

              {daysList.map((day) => (
                <FormControlLabel
                  key={day.id}
                  sx={{ alignItems: "center" }}
                  control={
                    <Checkbox
                      checked={selectedDay.includes(day.id)}
                      onChange={(e) => handledaysChange(e, day.id)}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                    />
                  }
                  label={
                    <Typography variant="h6">{day.week_short_name}</Typography>
                  }
                />
              ))}
            </>
          </Box>

          <FormHelperText>{errors.selectedDay}</FormHelperText>
        </Grid>

        <Grid item xs={12} lg={6}>
          <Typography variant="h6">
            Slot Start Time{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <TextField
            size="small"
            fullWidth
            type="time"
            value={startTime}
            onChange={handleStartTimeChange}
            InputLabelProps={{
              shrink: true,
            }}
       error={Boolean(errors.startTime)}
            helperText={errors.startTime}
            InputProps={{ style: { borderRadius: "10px" } }}
          />
        </Grid>

        <Grid item xs={12} lg={6}>
          <Typography variant="h6">
            Slot End Time{" "}
            <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span>
          </Typography>
          <TextField
            size="small"
            fullWidth
            type="time"
            value={endTime}
            // onChange={(e) => setEndTime(e.target.value)}
            onChange={handleEndTimeChange}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.endTime)}
            helperText={errors.endTime}
            InputProps={{ style: { borderRadius: "10px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography>Note : All times are displayed in 24-hour format (IST).</Typography>
        </Grid>

       
        <Grid item xs={12}>
          {room_Teaching_mode === "online" && (
            <>
              <Typography variant="h6">Zoom Link <span
              style={{
                color: "red",
                position: "absolute",
                marginLeft: "4px",
                fontSize: "1em",
              }}
            >
              *
            </span></Typography>
              <TextField
                fullWidth
                value={zoomLink}
                onChange={(e) => setZoomLink(e.target.value)}
                size="small"
                error={Boolean(errors.zoomLink)}
                helperText={errors.zoomLink}
                InputProps={{ style: { borderRadius: "10px" } }}
              />
            </>
          )}
        </Grid>

        {/*} <TextField
          label="Capacity"
          fullWidth
          type="number"
          value={capacity}
          onChange={(e) => setCapacity(e.target.value)}
          margin="normal"
        />*/}

        <Grid
          item
          xs={12}
          container
          justifyContent="end"
          gap={1}
          alignItems="center"
        >
          <Button onClick={handleCancel} color="error">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Create Class
          </Button>
        </Grid>
      </Grid>{" "}
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
};

export default CreateClassDialog;
